// extracted by mini-css-extract-plugin
export default {"notice-container":"CookieNotice_notice-container__QeT6k","notice-content":"CookieNotice_notice-content__EkQG-","notice-button":"CookieNotice_notice-button__EJsAV"};